<section class="nhsuk-grid-row m-w-1200 mx-auto">
  <h2 class="nhsuk-heading-xl mb-16">What's new</h2>
  <a routerLink="/admin/whats-new/create"> Add a new version </a>

  <div class="nhsuk-grid-row mt-24">
    @for (whatsNewContentItem of whatsNewContentArray; track $index) {
      <div class="nhsuk-grid-column-two-thirds p-i-0 mb-16">
        <div class="p-24 bg-white border-light-grey shadow-light-grey flex flex-col full-height">
          <div class="flex space-between">
            <h2>{{ whatsNewContentItem.version }}</h2>
            <span>
              <strong class="nhsuk-tag" [ngClass]="displayStatusFlag(whatsNewContentItem.status)">
                {{ whatsNewContentItem.status }}</strong
              >
            </span>
          </div>
          <a [routerLink]="'/admin/whats-new/edit/' + whatsNewContentItem.whatsNewGuid">Manage version</a>
        </div>
      </div>
    }
    @if (isLoading) {
      <div class="mt-16">
        <app-loading-spinner />
      </div>
    }
    @if (!isLoading && whatsNewContentArray.length === 0) {
      <div class="mt-16">
        <p>No versions found</p>
      </div>
    }
  </div>
</section>
